// Constants used only by the shared summary components.

// Reference the summaryType attribute in AimsPostSummaryEventTable DDB
export const SUMMARY_CLASSIFICATION_TYPE = {
  ATTORNEY_IN_ATTENDANCE: "attorney_in_attendance",
};
